import { render, staticRenderFns } from "./ConversationProviderManager.vue?vue&type=template&id=118f9fb2&"
import script from "./ConversationProviderManager.vue?vue&type=script&lang=js&"
export * from "./ConversationProviderManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports